/* ============================================================
   VELVAUSS THEME — Main JS
   ============================================================ */
(function () {
  'use strict';

  /* ── Helpers ── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);

  /* ── Header scroll ── */
  function initHeader() {
    const header = $('.v-header');
    if (!header) return;
    const check = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    on(window, 'scroll', check, { passive: true });
    check();
  }

  /* ── Announcement bar close ── */
  function initAnnouncement() {
    const btn = $('.v-announcement__close');
    const bar = $('.v-announcement');
    if (!btn || !bar) return;
    on(btn, 'click', () => {
      bar.remove();
      sessionStorage.setItem('v-ann-closed', '1');
    });
    if (sessionStorage.getItem('v-ann-closed')) bar.remove();
  }

  /* ── Drawers ── */
  function initDrawers() {
    const cartDrawer = $('#cart-drawer');
    const navDrawer  = $('#nav-drawer');

    function openCart() {
      if (!cartDrawer) return;
      cartDrawer.hidden = false;
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
    function closeCart() {
      if (!cartDrawer) return;
      cartDrawer.hidden = true;
      document.body.style.overflow = '';
    }
    function openNav() {
      if (!navDrawer) return;
      navDrawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      if (!navDrawer) return;
      navDrawer.hidden = true;
      document.body.style.overflow = '';
    }

    $$('[data-action="open-cart"]').forEach(el => on(el, 'click', openCart));
    $$('[data-action="open-nav"]').forEach(el => on(el, 'click', openNav));
    $$('[data-action="close-cart"]').forEach(el => on(el, 'click', closeCart));
    $$('[data-action="close-nav"]').forEach(el => on(el, 'click', closeNav));

    on(document, 'keydown', e => {
      if (e.key === 'Escape') { closeCart(); closeNav(); }
    });

    window.vOpenCart = openCart;
    window.vCloseCart = closeCart;
  }

  /* ── Cart API ── */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch (e) { console.error('Cart fetch error', e); }
  }

  function renderCartDrawer(cart) {
    const body = $('#cart-drawer-body');
    const countEls = $$('.v-cart-count');
    const badgeEl = $('#drawer-item-count');
    if (!body) return;

    const count = cart.item_count;
    countEls.forEach(el => { el.textContent = count; el.dataset.count = count; });
    if (badgeEl) badgeEl.textContent = count > 0 ? count : '';

    if (count === 0) {
      body.innerHTML = `
        <div class="v-cart-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="v-btn v-btn--dark" onclick="window.vCloseCart()">Shop now</a>
        </div>`;
      return;
    }

    const itemsHtml = cart.items.map(item => `
      <div class="v-cart-line" data-line-key="${item.key}">
        <div class="v-cart-line__img">
          <img src="${item.image ? item.image.replace(/\.(jpg|jpeg|png|webp)/, '_160x160.$1') : ''}" alt="${item.title}" width="80" height="80" loading="lazy">
        </div>
        <div class="v-cart-line__info">
          <div>
            <div class="v-cart-line__title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="v-cart-line__variant">${item.variant_title}</div>` : ''}
          </div>
          <div class="v-cart-line__bottom">
            <span class="v-cart-line__price">${formatMoney(item.final_line_price)}</span>
            <button class="v-cart-line__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>`).join('');

    body.innerHTML = `<div class="v-cart-lines">${itemsHtml}</div>`;

    const drawer = document.getElementById('cart-drawer');
    let foot = drawer.querySelector('.v-cart-drawer-foot');
    if (!foot) {
      foot = document.createElement('div');
      foot.className = 'v-cart-drawer-foot';
      drawer.querySelector('.v-drawer__panel').appendChild(foot);
    }
    foot.innerHTML = `
      <div class="v-cart-drawer-subtotal">
        <span>Subtotal</span>
        <strong>${formatMoney(cart.total_price)}</strong>
      </div>
      <a href="/cart" class="v-btn v-btn--outline v-btn--full" style="margin-bottom:10px;">View cart</a>
      <a href="/checkout" class="v-btn v-btn--dark v-btn--full">Checkout</a>
      <p class="v-cart-trust">Free shipping · Secure checkout · 90-day returns</p>`;

    $$('.v-cart-line__remove', body).forEach(btn => {
      on(btn, 'click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        });
        fetchCart();
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── Quick Add ── */
  function initQuickAdd() {
    $$('[data-quick-add]').forEach(btn => {
      on(btn, 'click', async e => {
        e.preventDefault();
        const variantId = btn.dataset.quickAdd;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          btn.textContent = 'Added!';
          fetchCart();
          setTimeout(() => window.vOpenCart && window.vOpenCart(), 200);
          setTimeout(() => { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000);
        } catch {
          btn.textContent = 'Error';
          btn.disabled = false;
        }
      });
    });
  }

  /* ── Cart page qty ── */
  function initCartPage() {
    $$('[data-qty-change]').forEach(btn => {
      on(btn, 'click', async () => {
        const key = btn.dataset.qtyChange;
        const dir = btn.dataset.dir;
        const valEl = btn.closest('.v-qty')?.querySelector('.v-qty__val');
        if (!valEl) return;
        let qty = parseInt(valEl.value, 10) + (dir === 'up' ? 1 : -1);
        if (qty < 0) qty = 0;
        valEl.value = qty;
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        const line = btn.closest('[data-line-key]');
        if (line) {
          const item = cart.items.find(i => i.key === key);
          const priceEl = line.querySelector('.v-cart-page-item__price');
          if (priceEl && item) priceEl.textContent = formatMoney(item.final_line_price);
          if (!item || item.quantity === 0) line.remove();
        }
        const subtotalEl = $('#cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        const totalEl = $('#cart-total');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        $$('.v-cart-count').forEach(el => { el.textContent = cart.item_count; });
        if (qty === 0 && !cart.item_count) window.location.reload();
      });
    });
  }

  /* ── Gallery ── */
  function initProductGallery() {
    const gallery = $('.v-product-gallery');
    if (!gallery) return;
    const main = $('.v-product-gallery__main img', gallery);
    const thumbs = $$('.v-product-gallery__thumb', gallery);
    thumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        const src = thumb.dataset.src;
        const srcset = thumb.dataset.srcset;
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Newsletter ── */
  function initNewsletterForms() {
    $$('.v-newsletter__form').forEach(form => {
      on(form, 'submit', e => {
        e.preventDefault();
        form.submit();
      });
    });
  }

  /* ── Sort ── */
  function initSort() {
    const sel = $('#sort-select');
    if (!sel) return;
    on(sel, 'change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
    const current = new URLSearchParams(window.location.search).get('sort_by');
    if (current) sel.value = current;
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initAnnouncement();
    initDrawers();
    initQuickAdd();
    initCartPage();
    initProductGallery();
    initNewsletterForms();
    initSort();
  });

})();
